<div class="banner-item col-12 p-0">
  <py-campaign-banner-carousel-item
    [description]="priceCampaignDetails?.description"
    [activeBannerEntry]="activeBannerEntry"
    [isBannerEntryStopped]="isBannerEntryStopped"
    (sendBannerEntryState)="onSendBannerEntryState($event)"
  ></py-campaign-banner-carousel-item>
</div>

<div class="items-managment-wrapper bg-dark mt-n1">
  <div class="col-12 justify-content-center d-none d-sm-flex py-8">
    <ng-container *ngTemplateOutlet="barItems; context: { $implicit: 'col-3' }"></ng-container>
  </div>

  <div class="d-flex d-sm-none w-100 side-scroll py-8">
    <div class="d-flex d-md-none action pl-3 pr-2">
      <button (click)="changeState()">
        <i nz-icon [nzType]="isBannerEntryStopped ? 'right' : 'pause'" nzTheme="outline"></i>
      </button>
    </div>

    <ng-container *ngTemplateOutlet="barItems; context: { $implicit: 'col-6' }"></ng-container>
  </div>
</div>

<ng-template #barItems let-colClass>
  <div
    class="item"
    *ngFor="let item of priceCampaignDetails?.entries; let last = last; let index = index"
    [ngClass]="{ 'mr-1': !last }"
    [ngClass]="colClass"
    (click)="selectActiveBannerEntryManually(index)"
  >
    <div class="progress">
      <div #progressBar [id]="'bar-' + item.id" class="progress-bar" role="progressbar" style="width: 0%"></div>
    </div>
    <div class="mt-2">
      {{ item?.text | ellipsis : { showLastString: false } }}
    </div>
  </div>
</ng-template>
